export default __webpack_public_path__ + "static/media/T.db816a24.svg";